import { useCallback, useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import {
  nextStep,
  prevStep,
  endGuide,
  selectGuideCurrentStep,
  selectGuideState,
} from '../courseGuideState';
import { validateStep } from '../utils/guideValidation';

export const useCourseGuideNavigation = () => {
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const currentStep = useSelector(selectGuideCurrentStep);
  const guideState = useSelector(selectGuideState);

  const handleNext = useCallback(() => {
    const { isValid } = validateStep(currentStep, guideState, t);
    if (isValid) {
      dispatch(nextStep());
    }
    return isValid;
  }, [currentStep, dispatch, guideState, t]);

  const handleBack = useCallback(() => {
    dispatch(prevStep());
  }, [dispatch]);

  const handleSkip = useCallback(() => {
    dispatch(endGuide());
  }, [dispatch]);

  const isNextDisabled = useMemo(() => {
    const { isValid } = validateStep(currentStep, guideState, t);
    return !isValid;
  }, [currentStep, guideState, t]);

  return {
    currentStep,
    handleNext,
    handleBack,
    handleSkip,
    isNextDisabled,
  };
};
